import baseApi from "./baseApi";
import apiPaths from "./apiPaths";

export class teamsApi extends baseApi {
    constructor(baseUrl: string, userId: string) {
        super(baseUrl, userId);
    }

    public async GetTeamsForMatch(matchId: string) {
        return await this.Get(apiPaths.GetTeamsForMatch(matchId));
    }

    public async GetTeams(seriesId: string, playerId: string, year: string, teamIds: string[]) {
        return await this.Post(apiPaths.GetTeams(seriesId, playerId, year), teamIds);
    }

    public async GetTeamsForSeason(seasonId: string) {
        return await this.Get(apiPaths.GetTeamsForSeason(seasonId));
    }
}